export const useRouterStore = defineStore('routerStore', () => {
  const router = ref(null)

  function setRouter(routerInstance) {
    router.value = routerInstance
  }
  
  return {
    router,
    setRouter,
  }
})
